<template>
  <div class="container-370 text-center">
    <div class="meeting-card-success">
        <div class="main-title mt-40">
            <p>予約申請が完了しました。</p>
        </div>
        <div class="sub-main-titlemt-5 mb-30 text-left">
            <p>承諾されるとご登録のメールアドレスにご連絡がありますので、今しばらくお待ちください。</p>
        </div>
        <div v-if="this.meeting && this.meeting.enable_askpay">
          <div v-if="meetingCategory === 1">
            <div class="flex-1 text-center">
              <button
                type="button"
                class="button z-index-2 default"
                :disabled="isLoading"
                :class="{'is-disabled': isLoading}"
                @click="getInfo"
              >{{ this.invoiceButtonMessage }}</button>
            </div>
            <div class="buttons-flex mb-10"></div>
          </div>
        </div>
        <div v-if="this.isPapError" class="text-error mb-10">
          オンライン決済機能で不明なエラーが発生しています。<br>
          しばらく経ってからご確認願います。
        </div>
    </div>
    <div class="overlay-pap-modal" v-show="showPapModal">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" @click="closeModal" class="button default buttons-flex">X 閉じる</button>
        </div>
        <div class="modal-body">
          <iframe id="completed_iframe"
            frameborder="0"
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import MeetingsApi from '@/api/meeting'
import MasterApi from '@/api/master'
import {apiErrorDialog} from '@/helpers'
import axios from 'axios'
import {
  PAYMENT_TEMPORARILY_SAVED,
  PAYMENT_REQUESTED,
  PAYMENT_REQUESTED_CASH_ON_DELIVERY,
  PAYMENT_COMPLETED,
  PAYMENT_EXPIRED,
  PAYMENT_ERROR,
  PAYMENT_CANCELED,
  PAYMENT_REQUESTED_CREATE_INVOICE,
  PAYMENT_REQUESTED_SETTING_SHIPPING_ADDRESS,
  PAYMENT_AKADEN,
  PAYMENT_NO_EXISTS_DATA,
  BUTTONS_NONE, // not use
  BUTTONS_ONLINE_PAYMENT,
  BUTTONS_PAYMENT_METHOD,
  BUTTONS_SHIPPING_ADDRESS,
  BUTTONS_PAYMENT_DETAIL,
  BUTTONS_CREATE_INVOICE, // not use
  BUTTONS_INVOICE_DETAIL, // not use
} from '@/const'

export default {
  props: {
    meeting: {type: Object, required: false},
    meetingCategory: {type: Number, default: 1},
    meetingId: {type: Number, default: 0}
  },
  data () {
    return {
      showPapModal: false,
      info: {},
      papBaseUrl: '',
      invoiceButtonMessage: '',
      isPapError: false,
      paymentStatus: null,
      buttonStatus: null,
      isLoading: false,
    }
  },
  methods: {
    async getInfo () {
      if (this.isLoading) return
      this.isLoading = true
      var meetingID = this.$route.params.id
      const headers = {
        'Authorization': `Bearer ${this.$auth.token()}`
      }
      try {
        switch (this.buttonStatus) {
          case BUTTONS_PAYMENT_METHOD:
          case BUTTONS_PAYMENT_DETAIL:
            const getInvoiceDetail = await MeetingsApi.getInvoiceDetail(meetingID, headers)
            this.info = getInvoiceDetail.data.data
            break
          case BUTTONS_SHIPPING_ADDRESS:
            const shippingAddress = await MeetingsApi.editShippingAddress(meetingID, headers)
            this.info = shippingAddress.data.data
            break
          case BUTTONS_ONLINE_PAYMENT:
            if (this.paymentStatus == PAYMENT_NO_EXISTS_DATA) {
              meetingID = this.meetingId
            }
            const onlinePaymentNoExists = await MeetingsApi.editPaymentMethod(this.meetingId, headers)
            this.info = onlinePaymentNoExists.data.data
            break
          default:
        }
        this.setUrl(this.info.url, this.info.token)
      } catch (error) {
        this.isLoading = false
        apiErrorDialog(this, error)
      }
    },
    async setUrl (url, token) {
      this.showPapModal = true
      var xhr = new XMLHttpRequest()

      if (url) {
        xhr.open('GET', url)
        xhr.onreadystatechange = handler
        xhr.responseType = 'blob'
        xhr.setRequestHeader('Authorization', `Bearer ${token}`)
        xhr.withCredentials = true
        xhr.send()
      }

      function handler() {
        if (this.readyState === this.DONE) {
          var data_url = URL.createObjectURL(this.response)
          document.querySelector('#completed_iframe').src = data_url
        }
      }
    },
    closeModal () {
      this.showPapModal = false
      this.isLoading = false
      document.querySelector('#completed_iframe').src = ''
    },
    async setPapBaseUrl () {
      const res = await MasterApi.get()
        .catch((error) => apiErrorDialog(this, error))
      if (!res) return
      this.papBaseUrl = res.data.data.pap_base_url
      this.setIsExistsPayment()
    },
    async setIsExistsPayment() {
      const resources = ['searchIdByServiceUniqueId', 'paymentStatus']
      const meetingID = this.$route.params.id
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }

      const resFromGetInvoiceIdApi = await axios.get(`${this.papBaseUrl}/${resources[0]}/${meetingID}`, {headers: headers})
      const invoiceId = resFromGetInvoiceIdApi.data.invoiceId
      if (invoiceId) {
        const resFromGetPaymentStatusApi = await axios.get(`${this.papBaseUrl}/${invoiceId}/${resources[1]}`, {headers: headers})
          .catch((error) => {
            this.paymentStatus = -2
          })
        this.paymentStatus = resFromGetPaymentStatusApi.data.paymentStatus
      } else {
        this.paymentStatus = PAYMENT_NO_EXISTS_DATA
      }

      switch (parseInt(this.paymentStatus)) {
        case PAYMENT_NO_EXISTS_DATA:
        case PAYMENT_CANCELED:
          this.invoiceButtonMessage = 'オンラインでの決済を希望する'
          this.buttonStatus = BUTTONS_ONLINE_PAYMENT
          break
        case PAYMENT_TEMPORARILY_SAVED:
        case PAYMENT_REQUESTED_CREATE_INVOICE:
          this.invoiceButtonMessage = '決済方法を確認する'
          this.buttonStatus = BUTTONS_PAYMENT_METHOD
          break
        case PAYMENT_REQUESTED_SETTING_SHIPPING_ADDRESS:
          this.invoiceButtonMessage = '配送先を設定する'
          this.buttonStatus = BUTTONS_SHIPPING_ADDRESS
          break
        case PAYMENT_REQUESTED:
        case PAYMENT_REQUESTED_CASH_ON_DELIVERY:
        case PAYMENT_COMPLETED:
        case PAYMENT_EXPIRED:
        case PAYMENT_ERROR:
        case PAYMENT_AKADEN:
          this.invoiceButtonMessage = 'お支払情報を確認する'
          this.buttonStatus = BUTTONS_PAYMENT_DETAIL
          break
        default:
          this.isPapError = true
      }
    },
  },
  created() {
    this.setPapBaseUrl()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/meetings/create/LastStep.vue